import { CaseStudyBlock } from './CaseStudyBlock';
export default CaseStudyBlock;
